import { ViewChild, ComponentFactoryResolver, ViewContainerRef, Component } from '@angular/core';
import { PaintService, UtilService, ActionService, ComponentService, HttpService, AppState, SaveCurrentViewAction, CtViewComponent, IBaseController, TokenResponseModel, PlusAlertsService, CryptoService, StoreService } from 'components';
import { ServiceLocator } from '../services/ServiceLocator';
import { finalize } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { ErrorService } from '../services/error.service';

@Component({
    selector: '',
    template: '',
    styles: ['']
})
export class BaseController implements IBaseController {

    @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;
    protected viewCode: string;
    protected components;
    protected id: string;
    protected view: CtViewComponent;
    protected viewNotFound: boolean;
    protected paintService: PaintService;
    protected utilService: UtilService;
    protected actionService: ActionService;
    protected componentService: ComponentService;
    protected httpService: HttpService;
    protected compiler: ComponentFactoryResolver;
    protected appStore: Store<AppState>;
    protected loggedUser: TokenResponseModel;
    protected datePipe: DatePipe;
    protected messageService: ToastrService;
    protected plusAlertService: PlusAlertsService;
    protected errorService: ErrorService;
    protected cryptoService: CryptoService;
    protected storeService : StoreService;

    constructor() {
        this.paintService = ServiceLocator.injector.get(PaintService);
        this.utilService = ServiceLocator.injector.get(UtilService);
        this.actionService = ServiceLocator.injector.get(ActionService);
        this.componentService = ServiceLocator.injector.get(ComponentService);
        this.httpService = ServiceLocator.injector.get(HttpService);
        this.compiler = ServiceLocator.injector.get(ComponentFactoryResolver);
        this.appStore = ServiceLocator.injector.get<Store<AppState>>(Store);
        this.datePipe = ServiceLocator.injector.get<DatePipe>(DatePipe);
        this.messageService = ServiceLocator.injector.get<ToastrService>(ToastrService);
        this.plusAlertService = ServiceLocator.injector.get<PlusAlertsService>(PlusAlertsService);
        this.errorService = ServiceLocator.injector.get<ErrorService>(ErrorService);
        this.cryptoService = ServiceLocator.injector.get<CryptoService>(CryptoService);
        this.storeService = ServiceLocator.injector.get<StoreService>(StoreService);

        this.appStore.select(store => store).subscribe((state: any) => {
            this.loggedUser = state.loggedUser;
        });
    }

    ngAfterContentInit() {
        this.setId('CT_' + this.viewCode);
    }

    ngAfterViewInit() {

        if (!this.loggedUser?.access_token) {
            this.httpService.useApikey = true;
        }

        this.paintService.paintChildrenV2(this.viewCode, this.compiler, this.target)
            .subscribe(
                response => {
                    this.setRoot(this.paintService.rootModel);
                    this.appStore.dispatch(new SaveCurrentViewAction(this));
                    this.loadView();
                },
                err => {
                    this.viewNotFound = true;
                    this.errorService.handleError(err);
                }
            );

    }

    loadView() {
        setTimeout(() => {
            if (this.view || this.viewNotFound) {
                if (!this.viewNotFound)
                    this.getRoot().onInitComponent();
 
            }
            else
                this.loadView();
        }, 500);
    }

    executeMethod(event, x) {
        let utls = this.componentService.getUtils();

        if (utls.indexOf(event.action) === -1)
            this[event.action](event, x.Data);
        else
            this.componentService[event.action](event, x.Data);
    }

    localAction(event: any, x) {
        return this.componentService[event.action](event, x ? (x.Data ?? x.data) : x);
    }

    getId(): string { return this.id; }
    setId(id: string): void { this.id = id; }
    getViewCode(): string { return this.viewCode }
    setViewCode(viewCode: string): void { this.viewCode = viewCode }
    getEndPoint(): string { return HttpService.ENDPOINT }
    getRoot(): CtViewComponent { return this.view }
    setRoot(view: CtViewComponent): void { this.view = view }
}
